/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MatchOperationsEventRejected
 */
export interface MatchOperationsEventRejected {
    /**
     * 
     * @type {string}
     * @memberof MatchOperationsEventRejected
     */
    clientEventId?: string | null;
    /**
     * 
     * @type {string}
     * @memberof MatchOperationsEventRejected
     */
    reason?: string;
}

/**
 * Check if a given object implements the MatchOperationsEventRejected interface.
 */
export function instanceOfMatchOperationsEventRejected(value: object): value is MatchOperationsEventRejected {
    return true;
}

export function MatchOperationsEventRejectedFromJSON(json: any): MatchOperationsEventRejected {
    return MatchOperationsEventRejectedFromJSONTyped(json, false);
}

export function MatchOperationsEventRejectedFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatchOperationsEventRejected {
    if (json == null) {
        return json;
    }
    return {
        
        'clientEventId': json['clientEventId'] == null ? undefined : json['clientEventId'],
        'reason': json['reason'] == null ? undefined : json['reason'],
    };
}

export function MatchOperationsEventRejectedToJSON(json: any): MatchOperationsEventRejected {
    return MatchOperationsEventRejectedToJSONTyped(json, false);
}

export function MatchOperationsEventRejectedToJSONTyped(value?: MatchOperationsEventRejected | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'clientEventId': value['clientEventId'],
        'reason': value['reason'],
    };
}

